import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appNavigable]',
})
export class NavigableDirective implements OnInit {
  @Input() mode: string;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    let disableLeftRight = true;

    this.elementRef.nativeElement.addEventListener('keydown', (event: KeyboardEvent) => {
      const keys = { left: 'ArrowLeft', up: 'ArrowUp', right: 'ArrowRight', down: 'ArrowDown' };
      let key = event.key;

      if (this.mode === 'excel') {
        if (key === 'Enter') {
          key = 'ArrowDown'; // in excel mode, treat the Enter key like the down arrow
        }
      } else {
        if (key === 'Enter') {
          disableLeftRight = !disableLeftRight; // in standard mode, the Enter key disables the left/right arrows
        }
      }

      // start at the currently focused element, must be an input for this to continue
      const startInput = document.activeElement as HTMLInputElement;
      if (startInput.nodeName !== 'INPUT') return;

      let destinationInput: HTMLInputElement | undefined;
      let node: HTMLElement | null = startInput;

      // walk along the DOM, looking for the destination input
      // look for the startInput's TD
      do {
        node = node.parentNode as HTMLElement;
      } while (node && node.nodeName !== 'TD');
      if (!node) return; // ill-formed html

      if (key === keys.up || key === keys.down) {
        event.preventDefault();
        const tdIndex = (node as HTMLTableCellElement).cellIndex;

        do {
          // find the TR
          node = node.parentNode as HTMLElement;
        } while (node && node.nodeName !== 'TR');
        if (!node) return; // ill-formed html

        do {
          node = (key === keys.up ? node.previousElementSibling : node.nextElementSibling) as HTMLElement;
          if (node && node.nodeName === 'TR') {
            destinationInput = this.firstVisibleInput(node, tdIndex);
          } else return; // no more rows or ill-formed html
        } while (!destinationInput);
      }

      if (destinationInput) {
        destinationInput.focus();
        destinationInput.select();
      }
    });

    // Add event listener for blur event on the currently focused input element
    document.addEventListener('blur', (event: FocusEvent) => {
      const target = event.target as HTMLElement;
      if (target.nodeName === 'INPUT') {
        disableLeftRight = true;
      }
    });
  }

  private firstVisibleInput(node: HTMLElement, tdIndex?: number): HTMLInputElement {
    if (tdIndex !== undefined) {
      node = node.children[tdIndex] as HTMLElement;
    }
    if (node) {
      const descendants = node.getElementsByTagName('*');
      for (let i = 0; i < descendants.length; i++) {
        const descendant = descendants[i] as HTMLInputElement;
        if (descendant.nodeName === 'INPUT' && descendant.offsetHeight > 0 && descendant.offsetWidth > 0) {
          return descendant;
        }
      }
    }
    return undefined;
  }
}
